// @flow

import React from 'react';
import Intro from './Intro';
import FactFigure from './FactFigure';
import Store from './Store';
import ParalaxScroller from '../../../components/paralaxScroller/ParalaxScroller';
import MenuPage from '../../../components/paralaxScroller/MenuPage';
import PracticalInfo from './PracticalInfo';
import type { ShoppingCenter } from '../../../types/shoppingCenterType';
import type { KeyFigureType } from '../../../types/marketingType';

type Props = {
  location: Location,
  shoppingCenters: ShoppingCenter[],
  isKeyFiguresLoading: boolean,
  keyFigures: KeyFigureType,
}

function MallData(props: Props) {
  return (
    <ParalaxScroller
      className="scrollable-content"
      scrollSelf
    >
      <div className="mall-datas">
        <MenuPage className="best-image" id="INTRO">
          <Intro />
        </MenuPage>
        <MenuPage id="FACT_FIGURES">
          <FactFigure
            location={props.location}
            baseShoppingCenterList={props.shoppingCenters}
            isKeyFiguresLoading={props.isKeyFiguresLoading}
            keyFigures={props.keyFigures}
          />
        </MenuPage>
        <MenuPage id="STORES">
          <Store />
        </MenuPage>
        <MenuPage id="PRACTICAL_INFO">
          <PracticalInfo />
        </MenuPage>
      </div>
    </ParalaxScroller>
  );
}

export default (MallData);
